/* eslint-disable max-len */
import styled, { css } from 'styled-components';
import {
    CloseButton,
    Flex,
    Heading,
    Tabs,
    TextButton,
    mediaMixin,
    spaceMixin,
    spacingMixin,
    token,
} from '@zillow/constellation';
import { Container } from '@zillow/zrs-comet';

const maxSearchBoxWidth = '370px';

export const StyledCloseButton = styled(CloseButton)`
    top: 16px;
    right: 16px;
    color: ${token('colors.white')};
    &:hover {
        background-color: rgba(255,255,255,0.3);
    }
`;

export const StyledHeadingContainer = styled(Container)`
    padding-left: ${spaceMixin('sm')};
    padding-right: ${spaceMixin('sm')};
    padding-top: ${spaceMixin('xl')};

    ${mediaMixin('lg', css`
        padding-right: ${spaceMixin('lg')};
    `)}

    ${mediaMixin('xxl', css`
        padding-left: 0px;
        padding-right: ${spaceMixin('sm')};
    `)}
`;

export const StyledHeading = styled(Heading)`
    ${spacingMixin};
`;

export const StyledFlexContainer = styled(Flex)`
    flex-direction: column;
    min-height: 94px;
    background: ${props => props.theme.ns().colors.white};
    border: solid 1px ${props => props.theme.ns().colors.gray200};
    border-radius: 3px;
    justify-content: space-evenly;

    ${mediaMixin('lg', css`
        justify-content: space-between;
        flex-direction: row;
    `)}

    /* 768 */
    .SubHeadingSection-Summary {
        align-self: center;
        margin-bottom: ${spaceMixin('sm')};
        line-height: 16px;
        text-align: left;

        ${mediaMixin('lg', css`
            align-self: center;
            margin-bottom: 0;
        `)}
    }

    .SearchBox {
        margin: unset;

        ${mediaMixin('lg', css`
            max-width: ${maxSearchBoxWidth};
        `)}
    }
`;

export const StyledRightSubFlexContainer = styled.div`
    display: flex;
    flex-grow: 2;
    justify-content: center;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    order: 0;
    width: 100%;

    ${mediaMixin('lg', css`
        order: 5;
        justify-content: flex-end;
    `)}
`;

export const StyledSearchBoxContainer = styled.div`
    width: 100%;
    max-width: ${maxSearchBoxWidth};
`;

export const StyledBrandBlueButton = styled(TextButton)`
    && {
        color: ${token('colors.brand')};
    }
`;

export const StyledTabsList = styled(Tabs.List)`
    border: none;
`;

export const StyledTab = styled(Tabs.Tab)`
    color: ${props => (props.isActive ? token('colors.brand') : token('colors.black'))};

    ${mediaMixin('lg', css`
        &&[aria-selected='true']:before {
            background-color: transparent;
        }
    `)}
`;
